import { render, staticRenderFns } from "./SilverTierModal.vue?vue&type=template&id=2cdb2a84&scoped=true"
import script from "./SilverTierModal.vue?vue&type=script&lang=js"
export * from "./SilverTierModal.vue?vue&type=script&lang=js"
import style0 from "./SilverTierModal.vue?vue&type=style&index=0&id=2cdb2a84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdb2a84",
  null
  
)

export default component.exports